export const GTC_TYPE_BUYER = "buyer";
export const GTC_TYPE_SUPPLIER = "supplier";

export type GtcType = typeof GTC_TYPE_BUYER | typeof GTC_TYPE_SUPPLIER;

// Keep in sync with python-be app/helpers/gtc_constants.py (TES-610).
// Increment versions together on each publish: v4 -> v5 -> v6 ...
// Published HTML SHA-256 lives only in python-be GTC_PUBLISHED_CONTENT_SHA256
// (looked up by type + version — not stored on each signature row).
export const CURRENT_GTC_VERSIONS: Record<GtcType, string> = {
  [GTC_TYPE_BUYER]: "v4",
  [GTC_TYPE_SUPPLIER]: "v4",
};

export const GTC_BUYER_PATH = "/marketplace/gtc-buyers";
export const GTC_SUPPLIER_PATH = "/marketplace/gtc-suppliers";
export const GTC_BUYER_LABEL = "Buyer General Terms and Conditions";
export const GTC_SUPPLIER_LABEL = "Supplier General Terms and Conditions";

export const GTC_CONSENT_LABEL = "I have read and agree to these terms.";
export const GTC_ACCEPT_BUTTON_LABEL = "Accept";
export const GTC_SCROLL_TO_ACCEPT_HINT =
  "Scroll to the end of the document to accept.";
export const GTC_SCROLL_ROOT_ID = "gtc-scroll-container";
export const GTC_SCROLL_END_THRESHOLD_PX = 8;
export const GTC_CLIENT_TIMEZONE_HEADER = "X-Client-Timezone";
